module.exports = __webpack_public_path__ + "assets/images/device_ios_mobile_sms.svg";